import { render } from "./smsDetail.vue?vue&type=template&id=5c621a74"
import script from "./smsDetail.vue?vue&type=script&lang=js"
export * from "./smsDetail.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__